module.exports = __webpack_public_path__ + "img/dog_card.49ca3197.png";